import React from 'react'
import { useMediaQuery } from '@mui/material'
import {
	HeaderWrapper,
	HeaderContainer,
	HeaderTitle,
	Title1,
	Title2,
} from '../StyledComponents'
import TopBar from './TopBar'
import NavMenu from './NavMenu'
import MobileHeader from './MobileHeader'

function Header() {
	const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'))
	
	if (isDesktop) {
		return (
			<HeaderWrapper>
				<TopBar />

				<HeaderContainer>
					<img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" width={100} height={100}/>
					<HeaderTitle>
						<Title1 variant="h5">Government of Uttar Pradesh</Title1>
						<Title2 variant="h4">Department of Development Authority</Title2>
					</HeaderTitle>
					<img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" width={100} height={100}/>
				</HeaderContainer>

				<NavMenu />
			</HeaderWrapper>
		)
	}

	return (
		<MobileHeader />
	)
}

export default Header
